import MuiCheckbox from '@mui/material/Checkbox'
import MuiFormControlLabel from '@mui/material/FormControlLabel'
import React from 'react'

import { FormElementProps } from './FormElementParts'

interface State {
  checked: boolean
}

class CheckboxElement extends React.Component<FormElementProps, State> {
  constructor(props) {
    super(props)
    this.state = {
      checked: props.value === 'true',
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setChecked(this.props.value)
    }
  }

  handleChange = (e) => {
    const { name } = this.props
    const value = e.target.checked ? 'true' : 'false'
    const { onChange } = this.props
    if (onChange) {
      onChange({ name, value })
    }
    this.setChecked(value)
  }

  setChecked = (value) => {
    this.setState({
      checked: value === 'true',
    })
  }

  render() {
    const { disabled, isRequired, label, name } = this.props
    const { checked } = this.state
    const labelId = `label-${name}`

    return (
      <MuiFormControlLabel
        control={
          <MuiCheckbox
            aria-checked={checked}
            aria-labelledby={labelId}
            checked={checked}
            disabled={disabled}
            id={name}
            name={name}
            onChange={this.handleChange}
            required={isRequired}
          />
        }
        label={
          <span
            dangerouslySetInnerHTML={{
              __html: label || '',
            }}
          />
        }
      />
    )
  }
}

export default CheckboxElement
